import { ITableOption } from '../../interface/table/Table'

export const defaultTableOption: Readonly<Required<ITableOption>> = {
  tdPadding: [0, 5, 5, 5],
  defaultTrMinHeight: 42,
  defaultColMinWidth: 40,
  defaultBorderColor: '#000000'
}
